export default __webpack_public_path__ + "static/media/sv.2859c9f1.png";